export default __webpack_public_path__ + "static/media/weapons01.52283e8d.png";